// Per-route SEO for kosmoswma.com
// Sets title, description, canonical, robots and social tags on every navigation.
// Works with vue-router 3 (Vue 2) and vue-router 4 (Vue 3); no extra packages.
//
// For new pages, add its path to PAGE_SEO below and to ROUTES in scripts/prerender.mjs.

export const SITE_URL = 'https://kosmoswma.com'

const DEFAULT_IMAGE = SITE_URL + '/assets/logo-cropped.jpg'

export const PAGE_SEO = {
  '/': {
    title: 'Kosmos | Authentic Greek Restaurant & Bar in Walpole, MA',
    description:
      'Authentic Greek restaurant and bar on Main St in Walpole, MA. Mezedes, seafood, lamb, steak and craft cocktails. Dine-in, pickup, catering and private events.',
  },
  '/menu': {
    title: 'Menu | Kosmos Greek Restaurant in Walpole, MA',
    description:
      'Dinner, weekend lunch, cocktail and dessert menus at Kosmos in Walpole, MA: saganaki, grilled octopus, lamb chops, lavraki, lobster pasta and more.',
  },
  '/catering': {
    title: 'Greek Catering in Walpole, MA | Kosmos',
    description:
      'Greek catering from Kosmos in Walpole, MA. Pans of moussaka, pastitsio, chicken skewers, salmon and salads, plus lamb chops and spanakopita by the dozen.',
  },
  '/contact': {
    title: 'Contact & Private Events | Kosmos, Walpole MA',
    description:
      'Contact Kosmos at 944 Main St, Walpole, MA. Call (508) 921-3086 or send a message about private events, catering and reservations. Open Tuesday to Sunday.',
  },
}

const NOT_FOUND = {
  title: 'Page not found | Kosmos Greek Restaurant',
  description: 'This page does not exist. Visit the Kosmos homepage for our menu, hours and reservations.',
  noindex: true,
}

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function normalizePath(path) {
  const trimmed = path.replace(/\/+$/, '')
  return trimmed === '' ? '/' : trimmed
}

export function applySeo(to) {
  const path = normalizePath(to.path)
  const routeSeo = (to.meta && to.meta.seo) || {}
  // Not found = the catch-all route (meta: { notFound: true }) or no route matched at all.
  // A real page missing from PAGE_SEO falls back to the homepage text rather than being noindexed.
  const isNotFound = Boolean(to.meta && to.meta.notFound) || to.matched.length === 0
  const base = isNotFound ? NOT_FOUND : PAGE_SEO[path] || PAGE_SEO['/']
  const seo = { image: DEFAULT_IMAGE, ...base, ...routeSeo }
  const url = SITE_URL + (path === '/' ? '/' : path)

  document.title = seo.title
  upsertMeta('name', 'description', seo.description)
  upsertMeta('name', 'robots', seo.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large')

  upsertMeta('property', 'og:title', seo.title)
  upsertMeta('property', 'og:description', seo.description)
  upsertMeta('property', 'og:url', url)
  upsertMeta('property', 'og:image', seo.image)
  upsertMeta('name', 'twitter:title', seo.title)
  upsertMeta('name', 'twitter:description', seo.description)
  upsertMeta('name', 'twitter:image', seo.image)

  if (!seo.noindex) upsertCanonical(url)
  else {
    const stale = document.head.querySelector('link[rel="canonical"]')
    if (stale) stale.remove()
  }
}

export function installSeo(router) {
  router.afterEach((to) => applySeo(to))
}
